<template>
  <b-container>
    <b-row ref="register" :class="registerHeight" class="mx-auto" align-h="center" align-v="center">
      <!--<clip-loader :loading="isLoaded" color="#e53f2e" size="35px" margin="35px"
                   class="Center container"></clip-loader>-->
      <b-col v-if="!isLoaded">
        <b-row>
          <b-col>
            <h2>{{ $t('registerTitle') }}</h2>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-form-group
                id="fieldset-11"
                :label="$t('labelName')"
                label-for="input-11"
                :invalid-feedback="invalidFeedbackName"
                :state="verifyName"
            >
              <b-form-input v-on:keyup.enter="verifyForm" id="input-11"
                            v-bind:placeholder="$t('placeHolderName')" v-model="name" :state="verifyName"
                            trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-form-group
                id="fieldset-4"
                :label="$t('loginLabelCompany')"
                label-for="input-4"
                :state="verifyCompany"
            >
              <b-form-input v-on:keyup.enter="verifyForm" id="input-4" v-model="company"
                            v-bind:placeholder="$t('loginPlaceHolderCompany')" :state="verifyCompany"
                            trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-form-group
                id="fieldset-22"
                :label="$t('loginLabelEmail')"
                label-for="input-22"
                :invalid-feedback="invalidFeedbackEmail"
                :state="verifyEmail"
            >
              <b-form-input v-on:keyup.enter="verifyForm" id="input-22" v-model="email"
                            v-bind:placeholder="$t('loginPlaceHolderEmail')" :state="verifyEmail"
                            trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-group
                id="fieldset-3"
                :label="$t('registerLabelPassword')"
                label-for="input-3"
                :invalid-feedback="invalidFeedbackPassword"
                :state="verifyPassword"
            >
              <b-form-input v-on:keyup.enter="verifyForm"
                            v-bind:placeholder="$t('loginPlaceHolderPassword')" type="password"
                            id="input-3" v-model="password" :state="verifyPassword" trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-group
                id="fieldset-5"
                :label="$t('registerLabelRepeatedPassword')"
                label-for="input-5"
                :invalid-feedback="invalidFeedbackPassword"
                :state="verifyPassword"
            >
              <b-form-input v-on:keyup.enter="verifyForm"
                            v-bind:placeholder="$t('loginPlaceHolderPassword')" type="password"
                            id="input-5" v-model="repeatedPassword" :state="verifyPassword"
                            trim></b-form-input>
            </b-form-group>

          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <span>
              {{ $t('registerLegalText1') }}
            </span>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-form-checkbox
                id="checkbox-1"
                v-model="accepted"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
            >
              <label>
                <b>
                  {{ $t('acceptTerms') }}
                </b>

              </label>
            </b-form-checkbox>
          </b-col>
          <label>{{ $t('reciveLabelInfo') }}</label>
          <b-col>
            <b-form-radio-group v-model="acceptInformation">
              <b-form-radio v-model="acceptInformation" name="some-radios" :value="true">{{ $t('reciveInfoYes') }}
              </b-form-radio>
              <b-form-radio v-model="acceptInformation" name="some-radios" :value="false">{{ $t('reciveInfoNo') }}
              </b-form-radio>
            </b-form-radio-group>
          </b-col>


          <b-col class="mt-4" cols="12">
            <b-button v-on:click="verifyForm" variant="light" class="form-control-sm colorBtn">
              {{ $t('registerBtnSubmit') }}
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <router-link to="/login" class="login" style="cursor: pointer">{{ $t('registerLabelLogin') }}</router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import app from "../firebaseConfig/config";
import apiService from "../service/service";


export default {
  name: "Register",
  props: {
    code: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      email: '',
      password: '',
      isLoaded: false,
      verifyEmail: null,
      verifyPassword: null,
      verifyCompany: null,
      invalidFeedbackEmail: '',
      invalidFeedbackPassword: '',
      name: '',
      company: '',
      verifyName: null,
      invalidFeedbackName: null,
      invalidFeedbackCompany: null,
      repeatedPassword: '',
      registerHeight: 'registerHeight',
      accepted: null,
      acceptInformation: true

    }
  },
  methods: {
    /**
     * Delete cookie that passes in name
     * @param name
     */
    deleteCookie(name) {

      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    },
    /**
     * Verify form that all data is correct for save to server
     */
    verifyForm() {
      this.verifyCompany = this.company.length !== 0 ? null : false
      this.verifyEmail = this.email.includes('@') && this.email.includes('.') ? null : false
      this.invalidFeedbackEmail = this.email.includes('@') && this.email.includes('.') ? '' : this.$i18n.t('errorMessageInvalidMailFormat').toString()
      this.verifyPassword = this.password.length > 6 && this.password === this.repeatedPassword ? null : false
      this.invalidFeedbackPassword = this.password.length > 6 ? '' : this.$i18n.t('errorMessageLengthPassword').toString()
      if (this.password.length > 6) {
        this.invalidFeedbackPassword = this.password === this.repeatedPassword ? null : this.$i18n.t('errorMessageSamePassword').toString()
      }
      this.verifyName = this.name.length > 0 && this.name.includes(' ') ? null : false
      this.invalidFeedbackName = this.name.length > 0 && this.name.includes(' ') ? '' : this.$i18n.t('errorMessageRequiredSurname').toString()
      if (!this.accepted) {
        this.$bvToast.toast(this.$i18n.t('errorMessageNoAcceptTerms').toString(), {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      if (this.verifyEmail === null && this.verifyPassword === null && this.verifyName === null && this.verifyCompany === null && this.accepted) {
        this.registerUser()
      }
    },
    /**
     * Register first user in firebase with an email and password and then save user data in firestore
     * @returns {Promise<void>}
     */
    async registerUser() {
      try {
        this.isLoaded = true
        await app.auth().signInAnonymously()

        const newUser = {
          name: this.name.split(' ')[0],
          surname: this.name.split(' ')[1],
          email: this.email,
          userCompany: this.company,
          company: "Barcelona Time Use",
          registerDate: new Date().toUTCString(),
          role: 'user',
          accepReciveInfo: this.acceptInformation,
          password: this.password
        }
        await apiService.createUser(newUser)

        this.$bvToast.toast(this.$i18n.t('successMessageUserRegister').toString(), {
          variant: 'success',
          solid: true
        })
        await this.$router.push({path: `/login`})
      } catch (e) {
        try {
          const acesToken = await app.auth().currentUser.getIdToken(true)
          await apiService.deleteUser({uid: app.auth().currentUser.uid}, acesToken)
        } catch (e) {
          console.log(e)
        }
        this.isLoaded = false
        if (e.response.data.error) {
          switch (e.response.data.error) {
            case 'This company is registered':
              this.$bvToast.toast(this.$i18n.t('errorMessageAlreadyRegistered').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
            default:
              this.isLoaded = false
              this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break

          }
        } else {
          this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        }

        this.invalidFeedbackPassword = this.$i18n.t('errorMessageCudNotConnectServer').toString()
        this.invalidFeedbackEmail = this.$i18n.t('errorMessageCudNotConnectServer').toString()
      }
    },
    /**
     * Verify Height of user widow for make Register more responsive
     */
    matchHeight() {
      const totalComponentsHeight = this.$refs.register.clientHeight + 87 + 100
      document.documentElement.clientHeight <= 919 ? this.registerHeight = 'min-vh-100' : this.registerHeight = 'registerHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')

      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
  },
  mounted() {
    this.registerHeight = 'min-vh-100'
    this.$store.commit('updateFooterClass', 'footerRelative')
    //this.matchHeight()
    /**
     * Add Listener when user resize window and check Height
     */
    //window.addEventListener("resize", this.matchHeight);
  },
  destroyed() {
    //window.removeEventListener("resize", this.matchHeight);
  }
}
</script>

<style scoped>
.login {
  font-weight: bold;
  color: black;
}

.registerHeight {
  height: 89vh;
}

.colorBtn {
  background-color: #39bac1;
}

</style>